import {createMaterialTopTabNavigator} from '@react-navigation/material-top-tabs';
import React, {useEffect} from 'react';
import {BaseScreen, TabBar} from 'src/design-system';
import {
  CoreBusinessHealth,
  // GrowthStrategicMetrics,
  OperationalEfficiency,
} from 'src/modules/practice-management/components';

import {compose} from 'recompose';
import {withDatabase} from '@nozbe/watermelondb/react';
import {mergeMap} from 'rxjs';
import {withObservables} from '@nozbe/watermelondb/react';
import withState from 'src/redux/wrapper';
import {Q} from '@nozbe/watermelondb';
import {useSessionDateSync} from 'src/hooks/useSessionDateSync';
import {subMonths} from 'date-fns';
import Spinner from 'react-native-loading-spinner-overlay';

const Navigator = createMaterialTopTabNavigator();

const DashboardScreen = ({route, organization}: any) => {
  const {isLoading, syncDateRange} = useSessionDateSync();

  useEffect(() => {
    const threeMonthsAgo = subMonths(new Date(), 3);
    const today = new Date();
    syncDateRange(threeMonthsAgo, today);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Spinner visible={isLoading} />
      <BaseScreen header={false}>
        <TabBar
          navigator={Navigator}
          location={'PracticeManagementDashboard'}
          route={route}>
          <Navigator.Screen name="Operational Efficiency">
            {() => <OperationalEfficiency organization={organization} />}
          </Navigator.Screen>

          <Navigator.Screen name="Core Business Health">
            {() => <CoreBusinessHealth organization={organization} />}
          </Navigator.Screen>
          {/* <Navigator.Screen name="Growth & Strategic Metrics">
          {() => <GrowthStrategicMetrics />}
        </Navigator.Screen> */}
        </TabBar>
      </BaseScreen>
    </>
  );
};

export default compose(
  withDatabase,
  withState,
  withObservables(['authentication'], ({authentication, database}: any) => ({
    organization: database
      ?.get('instances')
      .query(Q.where('_partition', authentication.selectedGroup))
      .observe()
      .pipe(mergeMap(x => x)),
  })),
)(DashboardScreen);
